const ignore = (..._args: any[]) => {};
export default ignore;
